<template>
  <div class="table-container-inner">
    <div>
      <button
          class="table-actions-button btn-green"
          type="button"
          @click="cancel()"
      >
        Назад
      </button>
      <button
          class="table-actions-button btn-green"
          type="button"
          @click="download()"
      >
        Скачать
      </button>
    </div>
    ВОСТРЕБОВАННЫЙ ЛИКВИД
    <table>
      <thead>
      <tr class="tr-fixed-height">
      <tr>
        <th>№ п/п</th>
        <th>АБП</th>
        <th>Категории товара</th>
        <th>Код ТМЗ (SAP, 1C)</th>
        <th>Полное наименование ТМЗ</th>
        <th>Ед. изм.</th>
        <th>Кол-во</th>
        <th>Цена</th>
        <th>Сумма</th>
        <th>Дата поступления</th>
      </tr>
      </thead>
      <tbody v-for="(request, index) in this.liquidDemandRequestDataDate" :key="request.id">
      <td>{{ index }}</td>
      <td>{{ request.abp }}</td>
      <td>{{ request.category }}</td>
      <td>{{ request.code_tmc }}</td>
      <td>{{ request.name_tmc }}</td>
      <td>{{ request.measure_unit }}</td>
      <td>{{ request.remains_before_tmz_count }}</td>
      <td>{{ request.remains_before_tmz_price }}</td>
      <td>{{ request.remains_before_tmz_sum }}</td>
      <td>{{ request.remains_receipt_date | formatDateTwo }}</td>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "LiquidDemandDataDate",
  data() {
    return {
      tmzReport: {},
      liquidDemandRequestDataDate: {}
    }
  },
  methods: {
    getLiquidDemandRequestDataDate() {
      this.$store.dispatch("getLiquidDemandRequestDataDate", this.$route.params.id).then((response) => {
        this.liquidDemandRequestDataDate = response;
      });
    },
    cancel() {
      history.back();
    },
    download () {
      let id = this.$route.params.id
      axios.get(`/tmz/liquid-demand-req-data/${id}/download_excel_date/`, {responseType: 'blob'}).then((response) => {
          const url = URL.createObjectURL(
              new Blob([response.data], {
                type: 'application/vnd.ms-excel',
              })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Разбивка по годам.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    }
  },
  created() {
    this.getLiquidDemandRequestDataDate();
  }
}
</script>

<style scoped>
.table-container {
  /* overflow-x: auto; */
  margin: 2rem;
  min-width: 1800px;
  /* margin: 0 auto; */
  overflow: auto;
}

.table-container-inner {
  padding: 0.5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  /* margin-right: 2rem; */
  /* margin: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 2rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  font-size: 14px;
}

.table-naming {
  font-size: 2rem;
  font-weight: bold;
  padding: 1rem 0;
  text-align: left;
}

.table-status {
  margin-bottom: 0.5rem;
}

th,
td {
  border: 1px solid #868686;
  padding: 0 1rem;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429e;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.table-actions {
  display: flex;
  padding: 2rem 0;
  justify-content: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
  margin: 0 auto;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-yellow {
  background: #ffbb56;
  color: white;
}

.btn-red {
  background: #e86363;
  color: white;
}

.btn-blue {
  background: #6c63e8;
  color: white;
}

.btn-upload-file {
  background: none;
  margin-left: -1rem;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-blue {
  background: #36429e;
  color: white;
}

.file-area {
  width: 100%;
  position: relative;
}

.file-area input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  border-radius: 25px;
}

.file-area .file-state {
  width: 100%;
  padding: 1rem 1rem;

  border-radius: 10px;
  /* margin-left: 1rem; */
  cursor: pointer;
  font-size: 1.1rem;

  background: #5769f8;
  color: #fff;
  text-align: center;
  transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
  display: none;
}

.file-area:hover .file-state {
  background: rgba(255, 255, 255, 0.1);
  color: black !important;
}


/* *[data-tooltip] {
  position: relative;
}

*[data-tooltip]::after {
  content: attr(data-tooltip);

  position: absolute;
  top: 50px;
  right: -50px;
  width: 150px;

  pointer-events: none;
  opacity: 0;
  -webkit-transition: opacity 0.15s ease-in-out;
  -moz-transition: opacity 0.15s ease-in-out;
  -ms-transition: opacity 0.15s ease-in-out;
  -o-transition: opacity 0.15s ease-in-out;
  transition: opacity 0.15s ease-in-out;

  display: block;
  font-size: 12px;
  line-height: 16px;
  background: #fefdcd;
  padding: 2px 2px;
  border: 1px solid #c0c0c0;
  box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.4);
}

*[data-tooltip]:hover::after {
  opacity: 1;
} */

.table-filter-container {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.table-filter-select {
  max-width: 400px;
}

.table-filter-submit {
  /* width: 200px; */
  /* height: 60px; */
  padding: .5rem 1rem;
  background: #36429e;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 10px;
  font-size: 1.2rem;
  cursor: pointer;
}

.filter-search-input {
  padding: 1rem 2rem;
  border-radius: 10px;
  border: 1px solid black;
}
</style>
